export const extractFileName = (value) => {
    if (!value || typeof value !== 'string') {
        return '';
    }

    // if value starts with transport transport@id: return what is after :
    const transportPrefixMatch = value.match(/^transport@[^:]+:(.+)$/);
    if (transportPrefixMatch) {
        return transportPrefixMatch[1];
    }
    // if is a http, https or rtsp return as is
    if (value.startsWith('http') || value.startsWith('https') || value.startsWith('rtsp')) {
        return value;
    }
    try {
        const url = new URL(value, window.location.origin);
        const pathname = url.pathname || '';
        const segments = pathname.split('/').filter(Boolean);
        if (segments.length > 0) {
            return segments[segments.length - 1];
        }
    } catch (error) {
        // not a valid URL, fall back to path splitting
    }

    const parts = value.split(/[\\/]/).filter(Boolean);
    if (parts.length > 0) {
        return parts[parts.length - 1];
    }

    return value;
};

export const coerceToString = (value) => {
    if (value === null || typeof value === 'undefined') {
        return '';
    }
    if (typeof value === 'string') {
        return value;
    }
    if (typeof value === 'number' || typeof value === 'boolean') {
        return String(value);
    }
    try {
        return JSON.stringify(value);
    } catch (error) {
        return '';
    }
};
